/**
 * The built-in brand theme (TMMAPP-0035, TMMAPP-0041, TMMAPP-0042) — rendered whenever the
 * tenant's theme is unavailable (first-visit timeout, any fetch failure, a malformed document)
 * and always checked by the contrast audit and the guarantee test.
 *
 * It IS saas-auth's `source: "platform-default"` document, vendored verbatim in
 * `fixtures/platform-default.v1.json` (provenance: `fixtures/SOURCE.md`) and read through the
 * same normalizer as a fetched theme, so a tenant with no brand and a tenant whose theme request
 * failed look identical. A vendored document the normalizer rejects throws at load (below), so
 * every test that imports the theme — and `contrastAudit.test.ts` by name — fails the gate.
 *
 * Identity is not applied here: `useBrand()` ignores `assets` and every copy key but the two
 * product names on any `source: "platform-default"` document (TMMAPP-0048), and ignores a name
 * equal to this built-in's no-tenant (platform) name — it supplies the catalog keys plus the app's
 * mark and favicon.
 */
import { normalizeBrandTheme, type BrandTheme } from './brandTheme';
import platformDefault from './fixtures/platform-default.v1.json';

function builtIn(): BrandTheme {
  const theme = normalizeBrandTheme(platformDefault);
  if (!theme) throw new Error('fixtures/platform-default.v1.json is not a valid v1 brand theme');
  return theme;
}

export const PLATFORM_DEFAULT_THEME: BrandTheme = builtIn();
